import { Link } from "react-router-dom";
import type { Article } from "@/lib/news";
import { formatDate, getArticleImage, getRelatedArticles } from "@/lib/news";

interface RelatedArticlesProps {
  article: Article;
}

export default function RelatedArticles({ article }: RelatedArticlesProps) {
  const related = getRelatedArticles(article, 4);
  if (related.length === 0) return null;

  return (
    <section className="mt-12">
      <div className="mb-5 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-links-line text-lg" />
        </span>
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
          相关推荐
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {related.map((item, index) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-stretch gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50/50 animate-fade-up cursor-pointer"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md">
              <img
                src={getArticleImage(item)}
                alt={item.title}
                title={item.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col justify-center">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="font-label text-primary-600">{item.categoryName}</span>
                <span>{formatDate(item.publishedAt)}</span>
              </div>
              <h3 className="mt-1 line-clamp-2 text-sm font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-600">
                {item.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}